import { IsString, MinLength, IsBoolean } from "class-validator";

export class AuthChangePasswordInputDTO {
	@IsString()
	currentPassword: string;
	
	@IsString()
	@MinLength(8)
	newPassword: string;
}

export class AuthChangePasswordOutputDTO {
	@IsBoolean()
	success: boolean;

	errors: {
		invalidPassword?: boolean
	}
}
